<template>
    <b-modal
        id="property-information-modal"
        class="property-information-modal"
        body-class="p-0"
        title-tag="h2"
        title-class="position-absolute"
        title="Edit Home Details"
        hide-footer
    >
        <b-form @submit.prevent="save" v-if="Boolean(orderAppResource._uuid)">
            <div class="border border-secondary border-right-0 border-left-0 pb-5 pt-5 px-4">
                <b-form-group class="pb-4">
                    <label
                        class="font-size-4 font-weight-bold mb-0"
                        for="street-address"
                    >
                        Street Address
                    </label>

                    <b-form-input
                        id="street-address"
                        v-model="streetAddress"
                        @input="validate()"
                    />

                    <b-form-invalid-feedback :state="validation.streetAddress">{{requiredMessage}}
                    </b-form-invalid-feedback>

                    <form-errors
                        :errors="formErrors"
                        field="streetAddress"
                    />
                </b-form-group>

                <b-form-row>
                    <b-col>
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="city"
                            >
                                City
                            </label>

                            <b-form-input
                                id="city"
                                v-model="city"
                                @input="validate()"
                            />

                            <b-form-invalid-feedback :state="validation.city">{{requiredMessage}}
                            </b-form-invalid-feedback>

                            <form-errors
                                :errors="formErrors"
                                field="city"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="zip"
                            >
                                Zip Code
                            </label>


                            <b-form-input
                                id="zip"
                                v-model="zip"
                                @input="validate()"
                            />

                            <b-form-invalid-feedback :state="validation.zip">{{requiredMessage}}
                            </b-form-invalid-feedback>

                            <form-errors
                                :errors="formErrors"
                                field="zip"
                            />
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>

            <div class="d-flex align-items-center modal-header">
                <h2>
                    Additional Seller Information
                </h2>
            </div>

            <div class="border border-secondary border-right-0 border-left-0 pb-5 pt-5 px-4">
                <b-form-row class="pb-4">
                    <b-col>
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="additional-seller-first-name"
                            >
                                First Name
                            </label>

                            <b-form-input
                                id="additional-seller-first-name"
                                v-model="additionalSellerFirstName"
                                @input="validate()"
                            />

                            <b-form-invalid-feedback :state="validation.additionalSellerFirstName">{{requiredMessage}}
                            </b-form-invalid-feedback>

                            <form-errors
                                :errors="formErrors"
                                field="additionalSellerFirstName"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="additional-seller-last-name"
                            >
                                Last Name
                            </label>

                            <b-form-input
                                id="additional-seller-last-name"
                                v-model="additionalSellerLastName"
                                @input="validate()"
                            />

                            <b-form-invalid-feedback :state="validation.additionalSellerLastName">{{requiredMessage}}
                            </b-form-invalid-feedback>

                            <form-errors
                                :errors="formErrors"
                                field="additionalSellerLastName"
                            />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="8">
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="additional-seller-email"
                            >
                                Email
                            </label>

                            <b-form-input
                                id="additional-seller-email"
                                v-model.trim="additionalSellerEmail"
                                @input="validate()"
                            />

                            <b-form-invalid-feedback :state="validation.additionalSellerEmail">Email is Invalid
                            </b-form-invalid-feedback>

                            <form-errors
                                :errors="formErrors"
                                field="additionalSellerEmail"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group>
                            <label
                                class="font-size-4 font-weight-bold mb-0"
                                for="additional-seller-phone"
                            >
                                Phone
                            </label>

                            <b-form-input
                                id="additional-seller-phone"
                                v-model="additionalSellerPhone"
                                @input="validate()"
                            />

                            <form-errors
                                :errors="formErrors"
                                field="additionalSellerPhone"
                            />
                        </b-form-group>
                    </b-col>
                </b-form-row>
            </div>
            <b-row align-h="center" class="p-4">
                <b-col cols="6">
                    <b-button block size="lg" type="submit" variant="primary" :disabled="!isValid">
                        <b-spinner v-if="saving" class="mr-1" small />
                        Save
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import './PropertyInformationModal.scss';
import {cloneDeep, get} from 'lodash';
import FormErrorsMixin from '@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin';
import {
    AWAITING_SIGNATURES,
    COMPLETE
} from '@sellers-shield-home-protection/ss-core-js/src/AppResources/LuOrderStatusAppResource';
import OrderPropertyAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderPropertyAppResource';
import SellerAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/SellerAppResource';
import OrderSellerAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderSellerAppResource';
import UserMixin from '@mixins/UserMixin';
import {isValidEmail} from "@helpers/email";
import {
    invitationMeta,
    invitationPropertyCity,
    invitationPropertyStreetAddress,
    invitationPropertyZip,
} from "@helpers/order";
import {ApiFilter, AppResourceSearch} from '@sellers-shield-home-protection/ss-core-js';
export default {
    name: 'PropertyInformationModal',
    mixins: [
        FormErrorsMixin,
        UserMixin,
    ],
    props: {
        orderAppResource: {
            type: Object,
        },
    },
    data: () => ({
        streetAddress: '',
        city: '',
        zip: '',
        stateId: '',
        additionalSellerFirstName: '',
        additionalSellerLastName: '',
        additionalSellerEmail: '',
        additionalSellerPhone: '',
        validation: {
            additionalSellerEmail: null,
            streetAddress: null,
            city: null,
            zip: null,
            additionalSellerLastName: null,
            additionalSellerLastName: null
        },
        saving: false,
        requiredMessage: 'This field is Required.'
    }),
    computed: {
        orderProperty() {
            return get(this.orderAppResource, 'property');
        },
        additionalSeller() {
            const sellers = get(this.orderAppResource, 'sellers');
            return sellers && sellers.toArray().find(seller => seller.type === 'secondary');
        },
        isValid() {
            return Object.values(this.validation).every(isValid => isValid);
        },
    },
    watch: {
        orderAppResource: {
            immediate: true,
            handler() {
                if (this.orderProperty || this.orderAppResource?.invitation?.meta?.property) {
                    this.streetAddress = this.orderProperty?.streetAddress || invitationPropertyStreetAddress(this.orderAppResource);
                    this.city = this.orderProperty?.city || invitationPropertyCity(this.orderAppResource);
                    this.zip = this.orderProperty?.zip || invitationPropertyZip(this.orderAppResource);
                    this.stateId = this.orderProperty?.stateId || (invitationMeta(this.orderAppResource).property || {}).state;
                }
                if (this.additionalSeller) {
                    this.additionalSellerFirstName = this.additionalSeller.firstName;
                    this.additionalSellerLastName = this.additionalSeller.lastName;
                    this.additionalSellerEmail = this.additionalSeller.email;
                    this.additionalSellerPhone = this.additionalSeller.phone;
                }
                this.validate();
            },
        },
    },
    methods: {
        validate() {
            this.$set(this.validation, 'streetAddress', Boolean(this.streetAddress)) ;
            this.$set(this.validation, 'city', Boolean(this.city));
            this.$set(this.validation, 'zip', Boolean(this.zip));

            let hasAdditionalSellerInformation = Boolean(this.additionalSellerEmail || this.additionalSellerFirstName || this.additionalSellerLastName || this.additionalSellerPhone);

            this.$set(this.validation, 'additionalSellerFirstName', Boolean((hasAdditionalSellerInformation && this.additionalSellerFirstName) || !hasAdditionalSellerInformation));
            this.$set(this.validation, 'additionalSellerLastName', Boolean(hasAdditionalSellerInformation && this.additionalSellerLastName || !hasAdditionalSellerInformation));
            
            this.$set(
                this.validation,
                'additionalSellerEmail',
                (this.additionalSellerEmail === null || this.additionalSellerEmail.length === 0) ||
                (this.additionalSellerEmail.length < 255 && isValidEmail(this.additionalSellerEmail))
            );
        },
        async saveOrderChanges(orderPropertyUuid = null, additionalSellerChanges = false) {
            let save = false, order = cloneDeep(this.orderAppResource);
            if (!this.orderProperty && orderPropertyUuid) {
                order.setAttribute('propertyUuid', orderPropertyUuid);
                save = true;
            }
            if (order.statusId === COMPLETE && (additionalSellerChanges || save)) {
                order.setAttribute('statusId', AWAITING_SIGNATURES);
                save = true;
            }
            !save || await order.save();
        },
        async saveOrderProperty() {
            let orderProperty = cloneDeep(this.orderProperty) || new OrderPropertyAppResource({
                attributes: {
                    orderUuid: this.orderAppResource.uuid,
                    stateId: this.stateId,
                }
            });
            orderProperty.setAttribute('streetAddress', this.streetAddress);
            orderProperty.setAttribute('city', this.city);
            orderProperty.setAttribute('zip', this.zip);
            await orderProperty.save();
            return orderProperty.uuid;
        },
        async saveAdditionalSeller() {
            let additionalSeller = cloneDeep(this.additionalSeller) || new SellerAppResource({});
            if (!!this.additionalSellerFirstName || !!this.additionalSellerLastName || !!this.additionalSellerEmail) {
                additionalSeller.setAttribute('firstName', this.additionalSellerFirstName);
                additionalSeller.setAttribute('lastName', this.additionalSellerLastName);
                additionalSeller.setAttribute('email', this.additionalSellerEmail ? this.additionalSellerEmail : null);
                additionalSeller.setAttribute('phone', this.additionalSellerPhone);
                additionalSeller.setAttribute('type', 'secondary');
                await additionalSeller.save();

                if (!this.additionalSeller) {
                    let orderSeller = new OrderSellerAppResource({});

                    orderSeller.setAttribute('sellerUuid', additionalSeller.uuid);
                    orderSeller.setAttribute('orderUuid', this.orderAppResource.uuid)
                    await orderSeller.save();

                    return true;
                }
            } else if (this.additionalSeller) {
                let orderSeller = new AppResourceSearch('order-seller');
                const searchData = {
                    filter: new ApiFilter({
                        params: {
                            sellerUuid: this.additionalSeller.uuid,
                            // orderUuid: this.orderAppResource.uuid, // commented because not - existing in laravel-data
                        },
                    }),
                };

                await orderSeller.setSearchData(searchData);
                await orderSeller.search();
                const orderSellers = orderSeller.appResourceCollection.toArray();

                for (const orderSellerItem of orderSellers) {
                    if (!!orderSellerItem.orderUuid && orderSellerItem.orderUuid === this.orderAppResource.uuid) {
                        await orderSellerItem.delete(); // delete order-seller
                    }
                }

                await additionalSeller.delete(); // delete seller

                return true;
            }

            return false;
        },
        async save() {
            this.validate();
            if (this.isValid) {
                await this.catchAppResourceErrors(async () => {
                    let orderPropertyUuid = await this.saveOrderProperty(),
                        additionalSellerChanges = await this.saveAdditionalSeller();

                    await this.saveOrderChanges(orderPropertyUuid, additionalSellerChanges);

                    this.$emit('save');
                }, 'saving');
            }
        },
    },
}
</script>
